const app = {
  name: 'Portal Aplikasi QHSE',
  company: 'PT Adhi Karya (Persero) Tbk.',
  guide: 'https://drive.google.com/file/d/1aef8JO6G34y2FPAI_nGQ1QGTdZDpBNqf/view',
  site: 'https://qhse.adhi-info.com',
  code: 'warehouse-adhi',
  logo: {
    sm: './static/img/logo/240x240.png',
    md: './static/img/logo/480x480.png',
    lg: './static/img/logo/720x720.png'
  },
  server: {
    stagging: 'https://adhi-portal.pttas.xyz/api',
    development: 'https://adhi-portal.pttas.xyz/api',
    production: 'https://manpower.adhi-info.com/api',
    demo: 'https://adhi-portal.pttas.xyz/api'
  },
  sso: {
    stagging: 'https://adhi-portal.pttas.xyz/api',
    development: 'https://adhi-portal.pttas.xyz/api',
    production: 'https://portal.adhi-info.com/api',
    demo: 'https://adhi-portal.pttas.xyz/api'
  },
  download: {
    android: 'https://play.google.com/store/',
    ios: 'https://www.apple.com/id/app-store/'
  },
  options: {
    allowRegister: true,
    forgetPassword: true,
    autofill: false,
    myAction: false,
    asideRight: false,
    sso: false
  }
}

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app



// WEBPACK FOOTER //
// ./src/config.js